module.exports = __webpack_public_path__ + "img/TUNE_GUN_METAL_BLACK.42c154db.png";